webpackJsonp([265584890008614],{

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-voter-1.2dc794d6.jpg";

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-voter-2.e75ab051.jpg";

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-voter-3.95097b55.jpg";

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Background-voter-4.b8d39163.jpg";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Dataownership-voter.6664eaad.png";

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Hero-voter.aca88af7.jpg";

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Homepage-voter.06750aa6.png";

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Letter-voter.a1e06a0f.png";

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Reliability-voter.c9db33cb.png";

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Segments-voter.b4f24827.png";

/***/ }),

/***/ 227:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.VoterQuery = undefined;
	
	var _Grid = __webpack_require__(5);
	
	var _Hero = __webpack_require__(13);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _ProductBar = __webpack_require__(14);
	
	var _ProductBar2 = _interopRequireDefault(_ProductBar);
	
	var _ContentBlock = __webpack_require__(6);
	
	var _ContentBlock2 = _interopRequireDefault(_ContentBlock);
	
	var _DividerImage = __webpack_require__(17);
	
	var _DividerImage2 = _interopRequireDefault(_DividerImage);
	
	var _HtmlContainer = __webpack_require__(8);
	
	var _HtmlContainer2 = _interopRequireDefault(_HtmlContainer);
	
	var _Image = __webpack_require__(11);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _OrderButton = __webpack_require__(18);
	
	var _OrderButton2 = _interopRequireDefault(_OrderButton);
	
	var _PricingContainer = __webpack_require__(19);
	
	var _PricingContainer2 = _interopRequireDefault(_PricingContainer);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TextSection = __webpack_require__(7);
	
	var _TextSection2 = _interopRequireDefault(_TextSection);
	
	var _reactJss = __webpack_require__(3);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _HeroVoter = __webpack_require__(497);
	
	var _HeroVoter2 = _interopRequireDefault(_HeroVoter);
	
	var _HomepageVoter = __webpack_require__(498);
	
	var _HomepageVoter2 = _interopRequireDefault(_HomepageVoter);
	
	var _LetterVoter = __webpack_require__(501);
	
	var _LetterVoter2 = _interopRequireDefault(_LetterVoter);
	
	var _SegmentsVoter = __webpack_require__(508);
	
	var _SegmentsVoter2 = _interopRequireDefault(_SegmentsVoter);
	
	var _DataownershipVoter = __webpack_require__(482);
	
	var _DataownershipVoter2 = _interopRequireDefault(_DataownershipVoter);
	
	var _ReliabilityVoter = __webpack_require__(507);
	
	var _ReliabilityVoter2 = _interopRequireDefault(_ReliabilityVoter);
	
	var _BackgroundVoter = __webpack_require__(478);
	
	var _BackgroundVoter2 = _interopRequireDefault(_BackgroundVoter);
	
	var _BackgroundVoter3 = __webpack_require__(479);
	
	var _BackgroundVoter4 = _interopRequireDefault(_BackgroundVoter3);
	
	var _BackgroundVoter5 = __webpack_require__(480);
	
	var _BackgroundVoter6 = _interopRequireDefault(_BackgroundVoter5);
	
	var _BackgroundVoter7 = __webpack_require__(481);
	
	var _BackgroundVoter8 = _interopRequireDefault(_BackgroundVoter7);
	
	var _Video = __webpack_require__(50);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    navcolour: {
	      backgroundColor: theme.colours.products.voter
	    },
	    voterHeroIcon: {
	      "@media (max-width: 823px)": {
	        marginTop: "1rem"
	      },
	      marginTop: "5rem"
	    },
	    contentBox: {
	      minHeight: "100vh"
	    },
	    contentSection: {
	      maxWidth: "100vw",
	      width: "100vw",
	      "@media (max-width: 1800px)": {
	        display: "none"
	      }
	    },
	    contentSectionMobile: {
	      "@media (min-width: 1800px)": {
	        display: "none"
	      }
	    },
	    mobileImage: {
	      width: "325px",
	      "@media (min-width: 1300px)": {
	        display: "none"
	      }
	    },
	    image: {
	      width: "550px",
	      "@media (max-width: 1300px)": {
	        display: "none"
	      }
	    },
	    contentSectionOne: {
	      maxWidth: "100vw",
	      width: "100vw",
	      "@media (max-width: 1800px)": {
	        display: "none"
	      }
	    },
	    contentSectionOneMedium: {
	      maxWidth: "100vw",
	      width: "100vw",
	      display: "none",
	      "@media (min-width: 1300px) and (max-width: 1800px)": {
	        display: "block"
	      }
	    },
	    contentSectionOneMobile: {
	      "@media (min-width: 1300px)": {
	        display: "none"
	      }
	    },
	    text: {
	      textAlign: "justify",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        maxWidth: "80vw"
	      },
	      "& h1": {
	        maxWidth: "60vw",
	        fontSize: "5.4rem",
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "2.8rem",
	          width: "100%",
	          maxWidth: "100%"
	        }
	      },
	      "& h2": {
	        fontSize: "2.2rem",
	        textAlign: "center",
	        fontWeight: 400
	      },
	      "& p": {
	        "@media (min-width: 824px)": {
	          width: "50vw",
	          marginRight: 0
	        }
	      }
	    },
	    fourthSectionText: {
	      maxWidth: "60vw",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        maxWidth: "80vw"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "2.8rem",
	          width: "100%",
	          maxWidth: "100%"
	        }
	      },
	      "& p": {
	        "@media (min-width: 824px)": {
	          maxWidth: "50vw",
	          marginLeft: "100px",
	          marginRight: 0
	        }
	      }
	    },
	    textColumns: {
	      maxWidth: "30vw",
	      paddingLeft: "10px",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        maxWidth: "80vw"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "2.8rem",
	          width: "100%"
	        }
	      },
	      "& h2": {
	        fontSize: "2.2rem",
	        textAlign: "center",
	        fontWeight: 400
	      }
	    },
	    pricingContainer: {
	      width: "100%"
	    },
	    pricing: {
	      width: "35vw",
	      "@media (max-width: 823px)": {
	        padding: 0,
	        width: "90%"
	      },
	      "& h1": {
	        fontSize: "5.4rem",
	        fontWeight: 400,
	        margin: 0,
	        textAlign: "center",
	        "@media (max-width: 823px)": {
	          fontSize: "2.8rem"
	        }
	      }
	    },
	    video: {
	      // iPad portrait mode
	      "@media (min-width: 824px) and (max-width: 1400px)": {
	        width: "400px",
	        height: "225px"
	      }
	    },
	    videoContainer: {
	      display: "flex",
	      alignItems: "center",
	      justifyContent: "center",
	      width: "100%"
	    }
	  };
	};
	
	var NavTabs = [{
	  tabLink: "#features",
	  tabName: "Features"
	}, {
	  tabLink: "#pricing",
	  tabName: "Pricing"
	}, {
	  tabLink: "/contact",
	  tabName: "Support"
	}];
	
	var VoterPage = function VoterPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _ProductBar2.default,
	      {
	        className: classes.navcolour,
	        logoLink: "/voter",
	        logoSrc: "/voter-logo.svg"
	      },
	      NavTabs.map(function (tab) {
	        return _react2.default.createElement(_ProductBar.Tab, { key: tab.tabName, tabLink: tab.tabLink, tabName: tab.tabName });
	      })
	    ),
	    _react2.default.createElement(
	      _Hero2.default,
	      { hero: _HeroVoter2.default, withBar: true },
	      _react2.default.createElement(
	        _Grid.Row,
	        { top: true, center: true },
	        _react2.default.createElement(
	          _Hero.HeroText,
	          null,
	          _react2.default.createElement(_Hero.HeroIcon, { src: "/voter-icon.png", className: classes.voterHeroIcon }),
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.HeroText.html })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "features" },
	      _react2.default.createElement(
	        "div",
	        { className: classes.contentSectionOne },
	        _react2.default.createElement(
	          _Grid.Row,
	          { center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.text },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstContentSection.html })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          _Grid.Row,
	          { middle: true, around: true },
	          _react2.default.createElement(_Image2.default, { image: _HomepageVoter2.default, className: classes.image }),
	          _react2.default.createElement(
	            "div",
	            { className: classes.videoContainer },
	            _react2.default.createElement(_Video2.default, {
	              name: "Caseworker.gov Video",
	              className: classes.video,
	              width: "100%",
	              height: "150%",
	              src: "//www.youtube.com/embed/G6lXdrwwAIg?rel=0&showinfo=0"
	            })
	          ),
	          _react2.default.createElement(_Image2.default, { image: _SegmentsVoter2.default, className: classes.image })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: classes.contentSectionOneMedium },
	        _react2.default.createElement(
	          _Grid.Row,
	          { center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.text },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstContentSection.html })
	          )
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          _Grid.Row,
	          { middle: true, center: true },
	          _react2.default.createElement(
	            "div",
	            { className: classes.videoContainer },
	            _react2.default.createElement(_Video2.default, {
	              name: "Caseworker.gov Video",
	              className: classes.video,
	              width: "100%",
	              height: "150%",
	              src: "//www.youtube.com/embed/G6lXdrwwAIg?rel=0&showinfo=0"
	            })
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null)
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(
	          _Grid.Row,
	          { middle: true, around: true },
	          _react2.default.createElement(_Image2.default, { image: _HomepageVoter2.default, className: classes.image }),
	          _react2.default.createElement(_Image2.default, { image: _SegmentsVoter2.default, className: classes.image })
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: classes.contentSectionOneMobile },
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.text },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.FirstContentSection.html })
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            "div",
	            { className: classes.videoContainer },
	            _react2.default.createElement(_Video2.default, {
	              name: "Caseworker.gov Video",
	              className: classes.video,
	              width: "100%",
	              height: "150%",
	              src: "//www.youtube.com/embed/G6lXdrwwAIg?rel=0&showinfo=0"
	            })
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(_Image2.default, { image: _LetterVoter2.default, className: classes.mobileImage }),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(_Image2.default, {
	            image: _SegmentsVoter2.default,
	            className: classes.mobileImage
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundVoter2.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        "div",
	        { className: classes.contentSection },
	        _react2.default.createElement(
	          _Grid.Row,
	          { center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.text },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentTitle.html })
	          )
	        ),
	        _react2.default.createElement(
	          _Grid.Row,
	          { around: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.textColumns },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentLeftSection.html })
	          ),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.textColumns },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentMidSection.html })
	          ),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.textColumns },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentRightSection.html })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: classes.contentSectionMobile },
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.text },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentTitle.html })
	          ),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.text },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentLeftSection.html })
	          ),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.text },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentMidSection.html })
	          ),
	          _react2.default.createElement(
	            _TextSection2.default,
	            { className: classes.text },
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.SecondContentRightSection.html })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundVoter4.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.text },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.ThirdContentSection.html })
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_Image2.default, { image: _DataownershipVoter2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _DataownershipVoter2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundVoter6.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox },
	      _react2.default.createElement(
	        _Grid.Col,
	        { middle: true, center: true },
	        _react2.default.createElement(
	          _TextSection2.default,
	          { className: classes.fourthSectionText },
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.FourthContentSection.html })
	        ),
	        _react2.default.createElement("br", null),
	        _react2.default.createElement(_Image2.default, { image: _ReliabilityVoter2.default, className: classes.image }),
	        _react2.default.createElement(_Image2.default, { image: _ReliabilityVoter2.default, className: classes.mobileImage })
	      )
	    ),
	    _react2.default.createElement(_DividerImage2.default, { image: _BackgroundVoter8.default }),
	    _react2.default.createElement(
	      _ContentBlock2.default,
	      { className: classes.contentBox, id: "pricing" },
	      _react2.default.createElement(
	        "div",
	        { className: classes.pricing },
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(
	            _TextSection2.default,
	            null,
	            _react2.default.createElement(_HtmlContainer2.default, { content: data.PricingSection.html })
	          )
	        ),
	        _react2.default.createElement(
	          _PricingContainer2.default,
	          null,
	          _react2.default.createElement(_HtmlContainer2.default, { content: data.PricingChecklist.html })
	        ),
	        _react2.default.createElement(
	          _Grid.Col,
	          { middle: true, center: true },
	          _react2.default.createElement(_OrderButton2.default, {
	            eventlabel: "Clicked Voter buy button",
	            mailinfo: "mailto:sales@electedtechnologies.com?subject=Voter.ID Sales Enquiry",
	            label: "Order Voter.ID Now",
	            phonenumber: "02 6169 1019"
	          })
	        )
	      )
	    )
	  );
	};
	
	VoterPage.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object
	};
	
	exports.default = (0, _reactJss2.default)(styles)(VoterPage);
	
	/* global graphql */
	
	var VoterQuery = exports.VoterQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-voter-jsx-538161a15f1769183978.js